import commissions from 'Agent/Commissions/ducks/commission';
import schedules from 'Agent/Commissions/ducks/commissionSchedules';
import a360Commissions from 'Agent/Commissions/ducks/a360Commissions'
import a360CommissionsReport from 'Agent/Commissions/ducks/a360CommissionsReport';

export default {
  commissions,
  schedules,
  a360Commissions,
  a360CommissionsReport
};
